import { Flex, Heading, IconHelp, List, Paragraph, Popover, Popper, Text } from '@zillow/constellation';
import FinicityLogo from './FinicityLogo';

const INCOME_VERIFICATION_TEXT = 'Automated income verification by';

export default function IncomeVerifiedByFinicityTag() {
  return (
    <Flex display="flex" gap={0.5} alignItems="center" id="verified-income-tag">
      <Text fontType="bodySmall">{INCOME_VERIFICATION_TEXT}</Text>
      <FinicityLogo />
      <Popper
        triggered={
          <Popover
            header={<Heading level={6}>Automated income verification</Heading>}
            body={
              <>
                <Paragraph>
                  Instead of sharing pay stubs or bank statements, applicants can have proof of income data directly
                  pulled from their bank account.
                </Paragraph>
                <List>
                  <List.Item>
                    <b>Verified amount:</b> The monthly average of regular direct deposit amounts, compiled from the
                    applicant’s connected accounts for up to 2 years.
                  </List.Item>
                  <List.Item>
                    <b>Verified source:</b> The name of the employer or institution that made regular ACH payment
                    transactions to the applicant. This data does not verify employment history.
                  </List.Item>
                </List>
                <Paragraph>
                  This is enabled by Zillow’s partnership with Experian and its affiliate, Finicity.
                </Paragraph>
              </>
            }
          />
        }
      >
        <Flex display="flex" alignItems="center" role="button" aria-label="income verification learn more">
          <IconHelp size="xs" />
        </Flex>
      </Popper>
    </Flex>
  );
}
